export default __webpack_public_path__ + "static/media/cdp-logo-white.f29a63a1.svg";